import wx from '@tencent/jweixin';
import { isMiniprogram } from '@utils/screen';

export const sendMessage = (path) => {
  if (!isMiniprogram()) return;

  wx.miniProgram.postMessage({ data: path });
};
